import { render } from "./기숙사검진.vue?vue&type=template&id=d0471e4a"
import script from "./기숙사검진.vue?vue&type=script&lang=js"
export * from "./기숙사검진.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__